/* eslint-disable no-undef */
import React, { useEffect, useState } from "react";
import { Table } from "antd";
import Breadcrumbs from "../../../../components/Breadcrumbs";
import GoalTrackingModal from "../../../../components/modelpopup/GoalTrackingModal";
import DeleteModal from "../../../../components/modelpopup/DeleteModal";
import ProtectedButton from "../../../../Routes/Approuter/ProtectedButton";
import {
  formatDateInTimezone,
  getCurrentDate,
} from "./../../../../utils/formatDateInTimezone";
import { companyID } from "../../../../auth";
import GoalActivationModal from "../../../../components/modelpopup/GoalActivationModal";
import api from "../../../../api/axios";

const GoalSetting = () => {
  const [paginationValue, setPaginationValue] = useState(5);
  const date = new Date();
  const current_year = date.getFullYear();
  const [show, setShow] = useState(false);
  const [handleData, setHandleData] = useState({});
  const [activationState, setActivationState] = useState(null);
  const [activationType, setActivationType] = useState(null);
  const emp_id = localStorage.getItem("employeeID");

  const activationHandler = (record, state, type) => {
    setShow(true);
    setHandleData(record);
    setActivationState(state);
    setActivationType(type);
  };

  const handleClose = () => {
    setShow(false);
    setHandleData({});
    setActivationState(null);
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "cycle_name",
    },
    {
      title: "Goal Applicability",
      dataIndex: "department_name",
      render: (text, record) => (
        <div
          className={`badge ${
            record?.department_name ? "badge-success" : "badge-info"
          }`}
          title={`Applicable for ${
            record?.department_name ? record?.department_name : "all department"
          }`}
        >
          {record?.department_name ?? "Default"}
        </div>
      ),
    },
    {
      title: "Goal cycle",
      dataIndex: "goal_cycle",
      render: (text, record) => (
        <>
          {`${formatDateInTimezone(record?.cycle_start_date) ?? "-"}`} to{" "}
          {`${formatDateInTimezone(record?.cycle_end_date) ?? "-"}`}
        </>
      ),
    },
    {
      title: "Goal Creation Deadline ",
      dataIndex: "goal_creation_deadline",
      render: (text, record) =>
        record?.goal_creation_deadline
          ? formatDateInTimezone(record?.goal_creation_deadline)
          : "-",
    },
    {
      title: "Performance Review Deadline",
      dataIndex: "self_review_deadline",
      render: (text, record) => (
        <>
          {record?.self_review_deadline
            ? formatDateInTimezone(record?.self_review_deadline)
            : "-"}
        </>
      ),
    },
    {
      title: "Appraisal deadline",
      dataIndex: "appraisal_deadline",
      render: (text, record) =>
        record?.appraisal_deadline
          ? formatDateInTimezone(record?.appraisal_deadline)
          : "-",
    },
    {
      title: "Goal Creation Status",
      dataIndex: "goal_creation_status",
      render: (text, record) => (
        <>
          {text == 0 ? (
            <span
              className="bg-danger badge"
              style={{ cursor: "pointer" }}
              onClick={() =>
                activationHandler(record, true, "Goal Creation Status")
              }
            >
              InActive
            </span>
          ) : (
            <span
              className="bg-success badge"
              style={{ cursor: "pointer" }}
              onClick={() =>
                activationHandler(record, false, "Goal Creation Status")
              }
            >
              Active
            </span>
          )}
        </>
      ),
    },
    {
      title: "Performnace Review Status",
      dataIndex: "self_review_status",
      render: (text, record) => (
        <>
          {text == 0 ? (
            <span
              className="bg-danger badge"
              style={{ cursor: "pointer" }}
              onClick={() =>
                activationHandler(record, true, "Performnace Review Status")
              }
            >
              InActive
            </span>
          ) : (
            <span
              className="bg-success badge"
              style={{ cursor: "pointer" }}
              onClick={() =>
                activationHandler(record, false, "Performnace Review Status")
              }
            >
              Active
            </span>
          )}
        </>
      ),
    },
  ];

  const [goalConfigurationData, setGoalConfihurationData] = useState([]);
  const company_id = companyID();

  const fetchConfiguration = async () => {
    try {
      const response = await api.get(
        `performance/companies/${company_id}/goal-cycle-configs`
      );
      if (response?.data?.configuration?.length > 0) {
        setGoalConfihurationData(response?.data?.configuration);
      }
    } catch (error) {
      console.error(error);
      setGoalConfihurationData([]);
    }
  };

  useEffect(() => {
    fetchConfiguration();
  }, []);

  return (
    <>
      <div className="page-wrapper">
        {/* Page Content */}
        <div className="content container-fluid">
          {/* Page Header */}
          <Breadcrumbs
            maintitle={`Goals Setting For ${new Date().getFullYear()}`}
            title="Dashboard"
            subtitle="Goal Setting"
            // modal="#add_goal"
            // name="Add New"
          />
          {/* /Page Header */}
          <div className="row">
            <div className="col-md-12">
              <div className="table-responsive">
                <Table
                  className="table-striped"
                  columns={columns}
                  dataSource={
                    goalConfigurationData.length > 0 && goalConfigurationData
                  }
                  pagination={{ pageSize: paginationValue }}
                  scroll={{ x: true }}
                />
              </div>
            </div>
          </div>
        </div>
        {/* /Page Content */}
      </div>
      <GoalTrackingModal />
      <GoalActivationModal
        fetchConfiguration={fetchConfiguration}
        handleClose={handleClose}
        activationState={activationState}
        handleData={handleData}
        show={show}
        goalConfigurationData={goalConfigurationData}
        activationType={activationType}
      />
    </>
  );
};

export default GoalSetting;
